<template>
  <div class="page-header">
    <v-btn icon depressed dark class="btn-back" @click="$emit('clickBack')">
      <v-icon dark>mdi-arrow-left</v-icon>
    </v-btn>
    <h3 class="page-title">{{propsTitle}}</h3>
  </div>
</template>
<script>
export default {
  props: {
    propsTitle: {
      type: String,
    },
  },
};
</script>
<style lang="scss">
.page-header {
  // margin-bottom: 1rem;
  padding: 1rem;
  text-align: center;
  background: $mid-green;
  color: #ffffff;
  border-radius: 0 0 20px 20px;
  .btn-back {
    position: absolute;
    left: 15px;
    top: 12px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 50%;
  }
  .page-title {
    font-size: 1.3em;
    color: #ffffff;
    margin-bottom: 0;
  }
}
</style>